import { commonSchemasMap, eventPropertyCountMap, version } from '@tunein/reporting-schemas';
import { fetchWithRetry } from '@tunein/web-utils';
import { mapValues, noop } from 'es-toolkit';
import { Validator } from '../Validator';
const schemaPromiseCacheMap = new Map();
async function getSchema(eventName) {
    if (schemaPromiseCacheMap.has(eventName)) {
        return schemaPromiseCacheMap.get(eventName);
    }
    const { promise, resolve } = Promise.withResolvers();
    schemaPromiseCacheMap.set(eventName, promise);
    const baseUrl = `https://cdn-web.tunein.com/assets/reporting-schemas/${version}/${eventName}.json`;
    let schema = await fetchWithRetry(baseUrl).catch(noop);
    if (!schema) {
        schema = await fetchWithRetry(`${baseUrl}?t=${Date.now()}`).catch(noop);
    }
    resolve(schema || {});
    return promise;
}
export const tuneInEventValidators = mapValues(eventPropertyCountMap, (_, eventName) => async () => {
    const schema = await getSchema(eventName);
    return new Validator(schema, {
        name: schema.$id || 'JSON_SCHEMA_FAILED_TO_LOAD',
        schemaReferences: commonSchemasMap,
    });
});
